import Alpine from 'alpinejs'

Alpine.data('collapsableContent', () => ({
    isMobile: () => window.matchMedia('(max-width: 48rem)').matches,
    isExpanded: true,
    isHighEnough: true,
    classes: {
        wrapperNode: '.collapsable-content',
        contentNode: '.collapsable-content__content',
        active: '.collapsable-content__content',
    },

    init() {
        let wrapper = this.$root;
        let content = wrapper.querySelector('.collapsable-content__content')
        let getContentHeight = () => content.getBoundingClientRect().height || content.scrollHeight;

        setTimeout(() => {
            let contentHeight = getContentHeight();

            wrapper.style.setProperty('--innerHeight', contentHeight + 'px');
            wrapper.style.setProperty('--duration', contentHeight + 'ms');
        }, 100);

        window.addEventListener('resize', () => {
            wrapper.style.setProperty('transition-property', 'none');
            let contentHeight = getContentHeight();

            wrapper.style.setProperty('--innerHeight', contentHeight + 'px');
            wrapper.style.setProperty('--duration', contentHeight/2 + 'ms');
            wrapper.style.setProperty('transition-property', null);
        });
    }
}));
